import { useEffect, useState } from "react"
import { collection, getDocs, getDoc, doc, onSnapshot, setDoc} from "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { FaArrowAltCircleDown, FaArrowAltCircleUp, FaArrowCircleUp } from "react-icons/fa";
import { AiOutlineDelete } from "react-icons/ai";

const firebaseConfig = {
    apiKey: "AIzaSyDvyFE51u8HLshOA9RPHIX49CqSpT62VU4",
    authDomain: "funnel-887b0.firebaseapp.com",
    databaseURL: "https://funnel-887b0.firebaseio.com",
    projectId: "funnel-887b0",
    storageBucket: "funnel-887b0.appspot.com",
    messagingSenderId: "948800714095",
    appId: "1:948800714095:web:289b59b34a9aec463ba49a",
    measurementId: "G-0TG7HL2T80"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore();



export default function CelebrityRow(props){

    const[celebData,setCelebData]=useState({"fullName":"loading.."});

    const listenForData = async() => {

        const unsubscribe= await onSnapshot(doc(db, "celebrities", props.id), (doc) => {

            if(doc.exists()===true){
                var temp= doc.data();
                setCelebData(temp);
            }
            else{
                setCelebData({"fullName":"./invalid./"})
            }
            
        });

    };

    useEffect(()=>{
        listenForData();
    },[celebData]);

    return(
        <div className="flex flex-row mb-2 justify-center items-center gap-2">
            <div className="bg-white/80 p-2 rounded text-black flex flex-row justify-between items-center">
                <div className="flex justify-center items-center">{celebData["fullName"]}</div>
                <div style={{backgroundImage:`url('${celebData["imgSrc"]}')`}} className="ml-5 bg-black h-12 w-12 bg-cover bg-center rounded"/>
            </div>

            <div className="ml-5 rounded text-black p-1 flex flex-row justify-center items-center">
                <AiOutlineDelete
                size={40}
                onClick={async ()=>{
                    let ref= await getDoc(doc(db,"appSettings","categories"));
                    let temp=ref.data()["categories"];
                    let tempList=temp[props.categoryIndex]["celebrities"];
                    tempList.splice(props.celebrityIndex,1);

                    let newData=ref.data()["categories"];
                    newData[props.categoryIndex]["celebrities"]=tempList;
                    console.log(newData);
                    await setDoc(doc(db,"appSettings","categories",),{"categories":newData},{merge:true});
                    
                }}
                className="bg-white p-1 rounded hover:scale-105 hover:bg-red-500 hover:text-red-500 text-sm"/>
            </div>


                <div className="flex flex-row items-center justify-center">
                    
                    <FaArrowAltCircleUp
                        onClick={async ()=>{
                        var data= (await getDoc(doc(db,"appSettings","categories"))).data();
                        var categoryList=data["categories"][props.categoryIndex]["celebrities"];
                        var previous=categoryList[props.celebrityIndex-1];
                        var current=categoryList[props.celebrityIndex];


                        if(props.celebrityIndex!=0){
                            categoryList[props.celebrityIndex-1]=current;
                            categoryList[props.celebrityIndex]=previous;
                            data["categories"][props.categoryIndex]["celebrities"]=categoryList;
                            await setDoc(doc(db,"appSettings","categories"),data,{merge:true});    
                        }
                    }}
                    className="hover:scale-110 " color="white" size={40} />


                    <FaArrowAltCircleDown
                        onClick={async ()=>{
                        var data= (await getDoc(doc(db,"appSettings","categories"))).data();
                        var categoryList=data["categories"][props.categoryIndex]["celebrities"];
                        var next=categoryList[props.celebrityIndex+1];
                        var current=categoryList[props.celebrityIndex];


                        if(props.celebrityIndex!=(categoryList.length-1)){
                            categoryList[props.celebrityIndex+1]=current;
                            categoryList[props.celebrityIndex]=next;
                            data["categories"][props.categoryIndex]["celebrities"]=categoryList;
                            await setDoc(doc(db,"appSettings","categories"),data,{merge:true});    
                        }
                    }}
                    className="hover:scale-110 " color="white" size={40} />


                </div>


        </div>
    )



}